import {ChangeDetectionStrategy, Component, computed, DestroyRef, Inject, Injectable, signal, viewChild} from "@angular/core";
import {MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef} from "@angular/material/dialog";
import {FormControl, FormGroup, FormsModule, ReactiveFormsModule} from "@angular/forms";
import {MatButtonModule} from "@angular/material/button";
import {AksjeeierbokId, AksjeeierEnkelModell, GruppeId, GruppeModell, GruppeRessursClient, MedlemId, MedlemsRolleModell, MøtedeltakerId, MøtedeltakerModell, MøteId, MøteModell, MøteRessursClient, OppdaterMøteSpesifikasjon, OppdaterMøteValideringsfeil} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {MatToolbarModule} from "@angular/material/toolbar";
import {MatIconModule} from "@angular/material/icon";
import {VisSpinnerDirektiv} from "web-ng2/delt/direktiver/button--visSpinner/button--visSpinner";
import {MøteRedigerDetaljerKontroller} from "../../komponenter/møte-rediger-detaljer/møte-rediger-detaljer";
import {BehaviorSubject, combineLatest, firstValueFrom, map, Observable, startWith} from "rxjs";
import {MøteRedigerTidspunktKontroller, MøteRedigerTidspunktKontrollerAvhengigheter, MøteRedigerTidspunktKontrollerAvhengigheter_DI_TOKEN, MøtetidspunktValideringsfeil} from "../../komponenter/møte-rediger-tidspunkt/møte-rediger-tidspunkt";
import {MøteRedigerDeltakereKontroller} from "../../komponenter/møte-rediger-deltakere/møte-rediger-deltakere";
import {MøteRedigerEksterneDeltakereKontroller} from "../../komponenter/møte-rediger-eksterne-deltakere/møte-rediger-eksterne-deltakere";
import {MatStepper, MatStepperModule} from "@angular/material/stepper";
import {TypetValideringsresultatModell} from "felles-ng2/tjenester/ressurser/ng2HttpKlientTilleggstyper";
import {erRepresentantForAksjeeierAngitt, GeneralforsamlingRedigerRepresentasjonerKontroller, medlemIdEllerInvitasjonId} from "web-ng2/moduler/møte/komponenter/generalforsamling-rediger-representasjon/generalforsamling-rediger-representasjoner";
import {AksjeeierDatatjeneste} from "felles-ng2/tjenester/datalager/AksjeeierDatatjeneste";
import {MatSlideToggleModule} from "@angular/material/slide-toggle";
import {finnAksjeeierRolle} from "felles-ng2/modell/gruppeModellHjelpere";
import {erIkkeNil, erNil} from "felles-ng2/støttefunksjoner/nilsjekk";
import {takeUntilDestroyed, toSignal} from "@angular/core/rxjs-interop";
import {TranslateModule} from "@ngx-translate/core";
import {Navigasjon} from "web-ng2/tjenester/Navigasjon";
import {i18n} from "felles-ng2/tjenester/i18n/Oversettelser";
import {GjeldendeTidssone, Tidssoneinformasjon} from "felles-ng2/tjenester/i18n/GjeldendeTidssone";
import {MedlemInvitasjonSkjemaKomponentAvhengigheter, MedlemInvitasjonSkjemaKomponentAvhengigheter_DI_TOKEN} from "web-ng2/moduler/medlem/komponenter/medlem-invitasjon-skjema/medlem-invitasjon-skjema";
import {eksistererMedlemMedEpost, eksistererMedlemMedNavn, medlemmerAktive, medlemmerIkkeAnonymisert, ValiderEpostRespons} from "felles-ng2/modell/medlemModellHjelpere";
import {Klokke} from "felles-ng2/tjenester/Klokke";
import {erMøteAvholdt, lesMøtedato2} from "felles-ng2/modell/møteModellHjelpere";
import {MøteDatatjeneste, MøteModellDLM} from "felles-ng2/tjenester/datalager/MøteDatatjeneste";
import {MøtedeltakereDatatjeneste} from "felles-ng2/tjenester/datalager/MøtedeltakereDatatjeneste";
import {DataOgMeta, kunRequestRespons, mapTilData, terminerEtterFørsteRequestRespons} from "felles-ng2/tjenester/datalager/DataOgMeta";
import {MøteRedigerDeltakereGeneralforsamlingKontroller} from "web-ng2/moduler/møte/komponenter/møte-rediger-deltakere-gf/møte-rediger-deltakere-gf";
import {møtedeltakerSpesifikasjonerFraAksjeeierRepresentasjonerOgMøtedeltakere} from "web-ng2/moduler/møte/modale/møte-opprett-dialog/møte-opprett-dialog";
import {erIkkeTomListe} from "felles-ng2/støttefunksjoner/lister";
import {VisDersomIkkeScrolletTilBunnDirektiv} from "web-ng2/delt/direktiver/visDersomIkkeScrolletTilBunn/visDersomIkkeScrolletTilBunn";
import {ZonedDateTimePeriodeLukket} from "felles-ng2/typer/ZonedDateTimePeriode";

const debug = initDebugger('MøteRedigerDialogRespons');

export type SkjemaType = MøteRedigerDialogKomponent['skjema']
export type SkjemaVerdier = SkjemaType['value'];

@Component({
    selector: 'moete-rediger-dialog',
    templateUrl: 'møte-rediger-dialog.html',
    styleUrls: ['møte-rediger-dialog.scss'],
    providers: [
        {provide: MøteRedigerTidspunktKontrollerAvhengigheter_DI_TOKEN, useExisting: MøteRedigerDialogKomponent},
        {provide: MedlemInvitasjonSkjemaKomponentAvhengigheter_DI_TOKEN, useExisting: MøteRedigerDialogKomponent}
    ],
    imports: [
        FormsModule,
        ReactiveFormsModule,
        MatButtonModule,
        MatDialogModule,
        MatIconModule,
        MatToolbarModule,
        MatStepperModule,
        VisSpinnerDirektiv,
        MøteRedigerDetaljerKontroller,
        MøteRedigerDeltakereKontroller,
        MøteRedigerEksterneDeltakereKontroller,
        GeneralforsamlingRedigerRepresentasjonerKontroller,
        MatSlideToggleModule,
        TranslateModule,
        MøteRedigerDeltakereGeneralforsamlingKontroller,
        VisDersomIkkeScrolletTilBunnDirektiv,
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MøteRedigerDialogKomponent implements MøteRedigerTidspunktKontrollerAvhengigheter, MedlemInvitasjonSkjemaKomponentAvhengigheter {

    /** Viser dialog for redigering av møte.
     * Merk at kun Steg.detaljer og Steg.deltakere er brukbare verdier pga stegene må traverseres sekvensielt, ergo ikke mulig å hoppe fra steg 1 direkte til steg 3 */
    static vis(dialog: MatDialog, møteId: MøteId, initieltSteg = Steg.detaljer): MatDialogRef<MøteRedigerDialogKomponent, MøteRedigerDialogRespons> {
        return dialog.open(MøteRedigerDialogKomponent, {data: {møteId, initieltSteg} as DialogParametre, disableClose: true, ariaLabelledBy: 'møte-rediger-dialog-tittel'/*, minHeight: 670*/});
    }

    private steg = viewChild.required<MatStepper>('steg');

    skjema = new FormGroup({
        sendInnkalling: new FormControl(true, {nonNullable: false}),
        detaljer: MøteRedigerDetaljerKontroller.opprettSkjema(),
        deltakere: MøteRedigerDeltakereKontroller.opprettSkjema(),
        eksterneDeltakere: MøteRedigerEksterneDeltakereKontroller.opprettSkjema(),
        /** aksjeeiere er kun relevant dersom gruppen har aksjeeierbok */
        aksjeeiere: GeneralforsamlingRedigerRepresentasjonerKontroller.opprettSkjema(),
    });

    /** møtet som redigeres, lastes av konstruktør */
    moete = signal<MøteModellDLM | null>(null);
    /** møtets deltakere, hentet fra datalager for møtedeltakere, lastes av {@link #setMøte} */
    deltakere = signal<MøtedeltakerModell[]>([]);
    /** gruppen møtet som redigeres er tilknyttet, lastes av {@link #lastGruppe} */
    gruppe = signal<GruppeModell | null>(null);
    /** Hvorvidt møte er avholdt eller ei */
    erAvholdt = computed(() => erIkkeNil(this.moete()) ? erMøteAvholdt(this.moete()!, this.klokke) : false);
    erGeneralforsamling = computed(() => this.gruppe()?.harAksjeeierbok ?? false);
    nyeDeltakereLagtTil = toSignal(this.nyeDeltakereLagtTilSomObserverbar(), {initialValue: []});

    standardAksjeeierRolle = signal<MedlemsRolleModell | null>(null);
    tilstand = signal<'laster' | 'lastet' | 'lagrer'>('laster');
    lagrer = computed(() => this.tilstand() == 'lagrer');

    /** angir hvilket steg som skal vises som aktivt når modalen vises */
    private initieltSteg = Steg.detaljer;
    /** Oppdateres via {@link #lastAksjeeiereOgOppdaterSkjema} */
    private medlemsroller$ = new BehaviorSubject<MedlemsRolleModell[]>([]);

    constructor(@Inject(MAT_DIALOG_DATA) parametre: DialogParametre,
                private avhengigheter: MøteRedigerDialogKomponentAvhengigheter,
                private klokke: Klokke,
                private navigasjon: Navigasjon,
                public dialogRef: MatDialogRef<MøteRedigerDialogKomponent, MøteRedigerDialogRespons>,
                private destroyRef: DestroyRef) {
        //sørger for at detaljer-skjema (som er arkfanene som vises initielt) ikke kan redigeres før ferske data er lastet,
        //blir enablet i this.setMøte(...)
        this.skjema.controls.detaljer.disable();
        this.initieltSteg = parametre.initieltSteg;
        this.avhengigheter.lastMøte(parametre.møteId)
          .pipe(terminerEtterFørsteRequestRespons())
          .subscribe(møteOgMeta => this.setMøte(møteOgMeta));
    }

    gaaTilRepresentasjonSteg() {
        this.gåTilSteg(Steg.representasjon);
    }

    gaaTilRedigerReferat() {
        this.avbryt();
        //når vi navigerer til rediger-protokoll må vi vente slik at navigasjonslås har blitt opphevet (webNavigasjon.reaktiverNavigasjon())
        //dette skjer i MøteTjeneste.redigerMøteDialog
        setTimeout(() => this.navigasjon.gåTilRedigerMøteProtokoll(this.moete()!.id), 100);
    }

    avbryt(): void {
        this.dialogRef.close(null);
    }

    async lagre() {
        this.tilstand.set('lagrer');
        try {
            const oppdatertMøte = await this.avhengigheter.oppdater(this.moete()!.id, this.somSpesifikasjon());
            const sendInnkalling = erIkkeTomListe(this.nyeDeltakereLagtTil()) && this.skjema.value.sendInnkalling!;
            this.dialogRef.close({oppdatertMøte, sendInnkalling, nyeDeltakere: this.nyeDeltakereLagtTil()});

        } catch (e) {
        } finally {
            this.tilstand.set('lastet');
        }
    }

    // MøteRedigerTidspunktKontrollerAvhengigheter impl

    validerMøtetidspunkt(møtedato: ZonedDateTimePeriodeLukket): Promise<TypetValideringsresultatModell<MøtetidspunktValideringsfeil>> {
        return this.avhengigheter.valider(this.moete()!.id, this.somSpesifikasjon(møtedato));
    }

    /** Ikke relevant ved redigering av møte */
    opprettNyÅrsplan(årstall: number): void {
    }

    // MedlemInvitasjonSkjemaKomponentAvhengigheter implementasjon

    medlemsroller(): Observable<MedlemsRolleModell[]> {
        return this.medlemsroller$;
    }

    verifiserAtEpostIkkeAlleredeErRegistrert(epost: string): ValiderEpostRespons {
        return eksistererMedlemMedEpost(this.somNullsikkerGruppemedlemmer(), epost);
    }

    /** Sann dersom det ikke finnes et medlem med samme navn (casing ignorert), ignorer permanent deaktiverte medlemmer */
    verifiserAtNavnIkkeAlleredeErRegistrert(navn: string): boolean {
        return eksistererMedlemMedNavn(medlemmerIkkeAnonymisert(this.somNullsikkerGruppemedlemmer()), navn);
    }

    //private hjelpemetoder

    private somNullsikkerGruppemedlemmer() {
        return this.gruppe()?.alleMedlemmer ?? [];
    }

    /** setter møte-betingede felter. Merk at denne metoden normalt blir kalt to ganger,
     * første gang med møte fra cache, andre gang med ferske data hentet fra server */
    private async setMøte(møte: DataOgMeta<MøteModellDLM>) {
        let møteVarIkkeInitialisert = erNil(this.moete());
        this.moete.set(møte.data);
        this.deltakere.set(await firstValueFrom(this.avhengigheter.lastMøtedeltakere(this.moete()!.id)));
        this.oppdaterSkjemaFraMøte();
        //sørger for å kalle lastGruppe etter at deltakere har blitt satt da oppdaterSkjemaFraGruppe (kalt av lastGruppe) forventer at deltakere er satt
        if (møteVarIkkeInitialisert) this.lastGruppe(møte.data.eiendeGruppeId);
        if (!møte.meta.levertFraCache) this.skjema.controls.detaljer.enable();
    }

    /** Oppdaterer modellen med data fra angitt mal. */
    private oppdaterSkjemaFraMøte() {
        const møte = this.moete()!;
        //legg til skjemarader for eksterne deltakere
        MøteRedigerEksterneDeltakereKontroller.repopulerSkjema(this.skjema.controls.eksterneDeltakere, møte.eksterneDeltakere);

        const møteverdier: SkjemaVerdier = {
            detaljer: {
                tidspunkt: MøteRedigerTidspunktKontroller.somSkjemaverdier(lesMøtedato2(møte), this.avhengigheter.tidssone.somZoneId()),
                behandlingsmaate: møte.behandlingsMaate,
                moetested: møte.behandlingsSted,
                formaal: møte.formaal
            }
            //deltakere: [] - denne strukturen har blitt satt via oppdaterSkjemaFraGruppe
            //eksterneDeltakere: [] - denne strukturen blir satt lenger opp
        };

        this.skjema.patchValue(møteverdier);
    }

    private async lastGruppe(gruppeId: GruppeId) {
        const gruppe = await this.avhengigheter.lastGruppe(gruppeId);
        this.gruppe.set(gruppe);
        this.tilstand.set('lastet');

        //vent til gui er oppdatert
        setTimeout(() => this.gåTilSteg(this.initieltSteg));

        this.oppdaterSkjemaFraGruppe();
        if (this.erGeneralforsamling()) this.lastAksjeeiereOgOppdaterSkjema();
    }

    private oppdaterSkjemaFraGruppe() {
        //legg til skjemarader for deltakere
        MøteRedigerDeltakereKontroller.repopulerSkjema(this.skjema.controls.deltakere, medlemmerAktive(this.gruppe()!.alleMedlemmer), this.deltakere(), this.destroyRef);
    }

    private lastAksjeeiereOgOppdaterSkjema() {
        combineLatest([
            this.avhengigheter.lastAksjeeiere(this.gruppe()!.aksjeeierbokId!).pipe(kunRequestRespons(), mapTilData()),
            this.avhengigheter.lastMedlemsroller(this.gruppe()!.id)])
          .pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe(([aksjeeiere, roller]) =>
            this.oppdaterSkjemaFraAksjeeiere(aksjeeiere, roller));
    }

    private oppdaterSkjemaFraAksjeeiere(aksjeeiere: AksjeeierEnkelModell[], medlemsroller: MedlemsRolleModell[]) {
        this.medlemsroller$.next(medlemsroller);
        this.standardAksjeeierRolle.set(finnAksjeeierRolle(medlemsroller))
        GeneralforsamlingRedigerRepresentasjonerKontroller.repopulerSkjema(this.skjema.controls.aksjeeiere, aksjeeiere, this.deltakere());
    }


    /** Returnerer spesifikasjon kan benyttes ved serverkall for validering/oppdatering.
     * Siden metoden også blir kalt ifbm validering er det ikke gitt at skjemaet er gyldig. */
    //public for testbarhet
    public somSpesifikasjon(møtedato: ZonedDateTimePeriodeLukket | null = null): OppdaterMøteSpesifikasjon {
        const skjemaverdier = this.skjema.value;
        const dato = erIkkeNil(møtedato) ? møtedato : MøteRedigerTidspunktKontroller.somMøteDato2(skjemaverdier.detaljer!.tidspunkt!, this.avhengigheter.tidssone);
        //merk at dersom ingen av feltene i skjemaverdier.detaljer er fylt ut vil skjemaverdier.detaljer være undefined
        return {
            dato: dato.somSerialiserbar(),
            behandlingsMaate: skjemaverdier.detaljer?.behandlingsmaate ?? '',
            behandlingsSted: skjemaverdier.detaljer?.moetested ?? '',
            deltakere: møtedeltakerSpesifikasjonerFraAksjeeierRepresentasjonerOgMøtedeltakere(skjemaverdier.aksjeeiere!, skjemaverdier.deltakere!),
            eksterneDeltakere: MøteRedigerEksterneDeltakereKontroller.somEksternMøtedeltakerSpesifikasjon(skjemaverdier.eksterneDeltakere!),
            formaal: skjemaverdier.detaljer?.formaal ?? '',
        };
    }

    /** Leverer en liste med MedlemId som representerer nye deltakere i møte.
     * Levere ny verdi hver gang det skjer endringer i deltakere eller aksjeeiere skjemaene */
    private nyeDeltakereLagtTilSomObserverbar(): Observable<MedlemId[]> {
        return combineLatest([
            //liste med medlemId for medlemmer satt til å delta
            this.skjema.controls.deltakere.valueChanges.pipe(
              startWith([]),
              map(deltakere => deltakere.filter(deltaker => deltaker.valgt)),
              map(valgteDeltakere => valgteDeltakere.map(deltaker => deltaker.medlem!.id))),
            //liste med medlemId for medlemmer satt til å representere aksjeeiere (enten id for eksisterende medlem eller id for nye medlem-invitasjon)
            this.skjema.controls.aksjeeiere.valueChanges.pipe(
              startWith([]),
              //filtrerer bort aksjeeiere som hverken har medlem eller nyInvitasjonForAksjeeier
              map(aksjeeiere => aksjeeiere.filter(aksjeeier => erRepresentantForAksjeeierAngitt(aksjeeier))),
              map(aksjeeiereMedRepresentant => aksjeeiereMedRepresentant.map(aksjeeier => medlemIdEllerInvitasjonId(aksjeeier)))
            )])
          .pipe(
            //lag liste med alle deltakere - som en liste av MedlemIder
            map(([valgteDeltakere, valgteRepresentanter]) => [...valgteDeltakere, ...valgteRepresentanter]),
            //filtrer bort medlemmer som var markert som deltakerer opprinnelig
            map(valgteMedlemmer => valgteMedlemmer.filter(medlemId => !this.deltakere().some(d => medlemId == d.medlem.id)))
          )
    }

    private gåTilSteg(steg: Steg) {
        switch (steg) {
            case Steg.detaljer:
                this.steg().selectedIndex = 0;
                break;
            case Steg.deltakere:
                this.steg().selectedIndex = this.erGeneralforsamling() ? 2 : 1;
                break;
            case Steg.representasjon:
                this.steg().selectedIndex = 1; //gir bare mening ved gf
                break;
        }
    }

}

export interface DialogParametre {
    møteId: MøteId;
    initieltSteg: Steg;
}

export enum Steg {
    detaljer = 0, deltakere = 1, representasjon = 2
}

export type MøteRedigerDialogRespons = { oppdatertMøte: MøteModell, sendInnkalling: boolean, nyeDeltakere: MøtedeltakerId[] } | null;

@Injectable()
export class MøteRedigerDialogKomponentAvhengigheter {

    constructor(private møteRessurs: MøteRessursClient,
                private gruppeRessurs: GruppeRessursClient,
                private møteDatatjeneste: MøteDatatjeneste,
                private møtedeltakereDatatjeneste: MøtedeltakereDatatjeneste,
                private aksjeeierDatatjeneste: AksjeeierDatatjeneste,
                private gjeldendeTidssone: GjeldendeTidssone) {
    }

    get tidssone(): Tidssoneinformasjon {
        return this.gjeldendeTidssone.brukersTidssone();
    }

    lastMøte(møteId: MøteId): Observable<DataOgMeta<MøteModellDLM>> {
        return this.møteDatatjeneste.hentMedMeta(møteId);
    }

    lastMøtedeltakere(møteId: MøteId): Observable<MøtedeltakerModell[]> {
        return this.møtedeltakereDatatjeneste.finnTilknyttetMøteFraLokallager(møteId);
    }

    lastGruppe(gruppeId: GruppeId): Promise<GruppeModell> {
        return this.gruppeRessurs.hent(gruppeId).somPromise();
    }

    lastAksjeeiere(aksjeeierbokId: AksjeeierbokId): Observable<DataOgMeta<AksjeeierEnkelModell[]>> {
        return this.aksjeeierDatatjeneste.finnAksjeeiereTilknyttetMedMeta(aksjeeierbokId);
    }

    lastMedlemsroller(gruppeId: GruppeId): Promise<MedlemsRolleModell[]> {
        return this.gruppeRessurs.finnTilgjengeligeRoller(gruppeId).somPromise();
    }

    valider(møteId: MøteId, spesifikasjon: OppdaterMøteSpesifikasjon): Promise<TypetValideringsresultatModell<OppdaterMøteValideringsfeil>> {
        return this.møteRessurs.validerOppdater(møteId, spesifikasjon)
          .somPromiseVisStandardMeldingVedFeil(i18n('Kunne ikke validere oppdatering av møte')) as Promise<TypetValideringsresultatModell<OppdaterMøteValideringsfeil>>;
    }

    oppdater(møteId: MøteId, spesifikasjon: OppdaterMøteSpesifikasjon): Promise<MøteModell> {
        debug('MøteRedigerDialogKomponentAvhengigheter.oppdater', spesifikasjon)
        return this.møteDatatjeneste.oppdater(møteId, spesifikasjon);
    }
}

